/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
export type Maybe<T> = T;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type BackofficeBaseResponseInterface = {
  creationUserId?: Maybe<Scalars['String']['output']>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type BackofficeResourceGroupFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  parentGroupId?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type BackofficeResourceGroupResponseInterface = {
  groupId: Scalars['String']['output'];
};

export type BackofficeResourceGroupResponseType = BackofficeBaseResponseInterface & BackofficeResourceGroupResponseInterface & {
  __typename?: 'BackofficeResourceGroupResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<LightSuperUserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  fullPaths: Array<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  groupType: ResourceGroupTypeEnum;
  isSystemGroup: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  parentGroupId?: Maybe<Scalars['String']['output']>;
  subGroups: PaginatedBackofficeResourceGroupResponseType;
  tenants: PaginatedTenantResponseType;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<LightSuperUserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};


export type BackofficeResourceGroupResponseTypeSubGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type BackofficeResourceGroupResponseTypeTenantsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export enum BillingDataFormatEnum {
  Csv = 'CSV',
  Default = 'DEFAULT',
  Excel = 'EXCEL',
  Json = 'JSON',
  Pdf = 'PDF'
}

export type BillingEntitlement = {
  __typename?: 'BillingEntitlement';
  allFeatures: Array<BillingFeatureEnum>;
  enabled: Scalars['Boolean']['output'];
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  feature: BillingFeatureEnum;
  metadata: Array<BillingMetadataItem>;
  provisionedUsage: BillingProvisionedUsage;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  serviceDescription?: Maybe<Scalars['String']['output']>;
  singleton: Scalars['Boolean']['output'];
  usageCatalog?: Maybe<BillingUsageCatalog>;
  usageType: BillingUsageTypeEnum;
};

export type BillingExport = {
  __typename?: 'BillingExport';
  dataFormat: BillingDataFormatEnum;
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BillingExpostProvisionedUsage = {
  __typename?: 'BillingExpostProvisionedUsage';
  billing?: Maybe<BillingProvisionedUsageBillingConfig>;
  enabled: Scalars['Boolean']['output'];
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
};

export enum BillingFeatureEnum {
  CreateAiCodeExplanation = 'CREATE_AI_CODE_EXPLANATION',
  CreateDevice = 'CREATE_DEVICE',
  CreateDocument = 'CREATE_DOCUMENT',
  CreateDocumentVersion = 'CREATE_DOCUMENT_VERSION',
  CreateProject = 'CREATE_PROJECT',
  CreateProjectVersion = 'CREATE_PROJECT_VERSION',
  Device = 'DEVICE',
  DeviceAgv = 'DEVICE_AGV',
  DeviceCnc = 'DEVICE_CNC',
  DeviceDrive = 'DEVICE_DRIVE',
  DeviceHmi = 'DEVICE_HMI',
  DeviceIndustrialSwitch = 'DEVICE_INDUSTRIAL_SWITCH',
  DeviceIpc = 'DEVICE_IPC',
  DeviceOther = 'DEVICE_OTHER',
  DevicePlc = 'DEVICE_PLC',
  DeviceRobot = 'DEVICE_ROBOT',
  DeviceScada = 'DEVICE_SCADA',
  Document = 'DOCUMENT',
  DocumentVersion = 'DOCUMENT_VERSION',
  EnterpriseAuth = 'ENTERPRISE_AUTH',
  EnterpriseSupport = 'ENTERPRISE_SUPPORT',
  Gateway = 'GATEWAY',
  LocalRunner = 'LOCAL_RUNNER',
  PocSupport = 'POC_SUPPORT',
  Project = 'PROJECT',
  ProjectVersion = 'PROJECT_VERSION',
  Rbac = 'RBAC',
  Recovery = 'RECOVERY',
  RunBackup = 'RUN_BACKUP',
  RunCompareProjectVersions = 'RUN_COMPARE_PROJECT_VERSIONS',
  RunConvertProject = 'RUN_CONVERT_PROJECT',
  RunDeployment = 'RUN_DEPLOYMENT',
  RunDevicePwRotation = 'RUN_DEVICE_PW_ROTATION',
  RunDeviceSnapshot = 'RUN_DEVICE_SNAPSHOT',
  RunDeviceSnapshotRestore = 'RUN_DEVICE_SNAPSHOT_RESTORE',
  RunFtpBackup = 'RUN_FTP_BACKUP',
  RunFtpRestore = 'RUN_FTP_RESTORE',
  RunJob = 'RUN_JOB',
  RunMergeProjectVersions = 'RUN_MERGE_PROJECT_VERSIONS',
  RunProjectBackup = 'RUN_PROJECT_BACKUP',
  RunProjectDeployment = 'RUN_PROJECT_DEPLOYMENT',
  RunReadDeviceVarList = 'RUN_READ_DEVICE_VAR_LIST',
  RunSmbBackup = 'RUN_SMB_BACKUP',
  RunSmbRestore = 'RUN_SMB_RESTORE',
  RunUpdateDeviceFw = 'RUN_UPDATE_DEVICE_FW',
  RunUpdateProjectLibs = 'RUN_UPDATE_PROJECT_LIBS',
  RunUpdateProjectOpcUaInterface = 'RUN_UPDATE_PROJECT_OPC_UA_INTERFACE',
  RunValidateLicense = 'RUN_VALIDATE_LICENSE',
  RunWriteDeviceVarList = 'RUN_WRITE_DEVICE_VAR_LIST',
  Secret = 'SECRET',
  SecurityVault = 'SECURITY_VAULT',
  ServicePackage = 'SERVICE_PACKAGE',
  SsoUser = 'SSO_USER',
  StandardUser = 'STANDARD_USER',
  Storage = 'STORAGE',
  TenantSetup = 'TENANT_SETUP',
  TimeConnectivitySra = 'TIME_CONNECTIVITY_SRA',
  TimeIdeaas = 'TIME_IDEAAS',
  TimeIdeaasGraphics = 'TIME_IDEAAS_GRAPHICS',
  TimeIdeaasSessionRecording = 'TIME_IDEAAS_SESSION_RECORDING',
  TokenSdai = 'TOKEN_SDAI',
  User = 'USER',
  VersionPro = 'VERSION_PRO'
}

export type BillingMetadataItem = {
  __typename?: 'BillingMetadataItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum BillingOperationEnum {
  EntDisable = 'ENT_DISABLE',
  EntEnable = 'ENT_ENABLE',
  EntManageExpost = 'ENT_MANAGE_EXPOST',
  EntManageUpfront = 'ENT_MANAGE_UPFRONT',
  EntSetCarryoverWindow = 'ENT_SET_CARRYOVER_WINDOW',
  EntSetQuantity = 'ENT_SET_QUANTITY',
  EntSetScope = 'ENT_SET_SCOPE',
  MetReserveUsage = 'MET_RESERVE_USAGE',
  SubsCancel = 'SUBS_CANCEL',
  SubsCreate = 'SUBS_CREATE',
  SubsSwitchPlan = 'SUBS_SWITCH_PLAN',
  SubsUpdate = 'SUBS_UPDATE',
  TermDurationAny = 'TERM_DURATION_ANY',
  TermDurationMonths = 'TERM_DURATION_MONTHS',
  TermNoticePeriod = 'TERM_NOTICE_PERIOD',
  TermStartAny = 'TERM_START_ANY',
  TermStartBackdate = 'TERM_START_BACKDATE',
  TermStartMonth = 'TERM_START_MONTH'
}

export enum BillingPeriodEnum {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Plan = 'PLAN',
  Tenancy = 'TENANCY',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type BillingPlan = {
  __typename?: 'BillingPlan';
  entitlements: Array<BillingEntitlement>;
  planType: BillingPlanTypeEnum;
  planVersion: Scalars['String']['output'];
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  term?: Maybe<BillingTerm>;
  tier: Scalars['String']['output'];
};

export enum BillingPlanTypeEnum {
  Individual = 'INDIVIDUAL',
  Initial = 'INITIAL',
  Resale = 'RESALE',
  Trial = 'TRIAL'
}

export type BillingPrice = {
  __typename?: 'BillingPrice';
  metadata: Array<BillingMetadataItem>;
};

export type BillingProportionalQuantity = {
  __typename?: 'BillingProportionalQuantity';
  coefficient: Scalars['String']['output'];
  dependerFeature: BillingFeatureEnum;
};

export type BillingProvisionedUsage = {
  __typename?: 'BillingProvisionedUsage';
  carryover?: Maybe<BillingProvisionedUsageCarryover>;
  description?: Maybe<Scalars['String']['output']>;
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  expost: BillingExpostProvisionedUsage;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  scope: BillingScopeParams;
  upfront: Array<BillingUpfrontProvisionedUsageItem>;
};

export type BillingProvisionedUsageBillingConfig = {
  __typename?: 'BillingProvisionedUsageBillingConfig';
  resellerPrice?: Maybe<BillingPrice>;
};

export type BillingProvisionedUsageCarryover = {
  __typename?: 'BillingProvisionedUsageCarryover';
  enabled: Scalars['Boolean']['output'];
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  window?: Maybe<Scalars['Int']['output']>;
};

export type BillingResellerContract = {
  __typename?: 'BillingResellerContract';
  term: BillingTerm;
};

export type BillingScopeParams = {
  __typename?: 'BillingScopeParams';
  period: BillingPeriodEnum;
};

export enum BillingSewBillingTypeEnum {
  CustomerBilling = 'CUSTOMER_BILLING',
  InternalCostCenter = 'INTERNAL_COST_CENTER',
  ProjectCostCenter = 'PROJECT_COST_CENTER'
}

export type BillingSewInternalCostCenterExport = {
  __typename?: 'BillingSewInternalCostCenterExport';
  fileName: Scalars['String']['output'];
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type BillingSewInternalCostCenterExportInput = {
  endBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  startBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingSewInternalSapExportInput = {
  billingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
};

export enum BillingSewRegionEnum {
  Belgium = 'BELGIUM',
  Finland = 'FINLAND',
  France = 'FRANCE',
  Germany = 'GERMANY',
  Italy = 'ITALY',
  Korea = 'KOREA',
  Netherlands = 'NETHERLANDS',
  Uk = 'UK',
  Usa = 'USA'
}

export type BillingSewSalesExport = {
  __typename?: 'BillingSewSalesExport';
  fileName: Scalars['String']['output'];
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type BillingSewSalesExportInput = {
  endBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  startBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingSewSapExport = {
  __typename?: 'BillingSewSapExport';
  fileName: Scalars['String']['output'];
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type BillingSewSapExportInput = {
  billingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  region: BillingSewRegionEnum;
};

export type BillingSewSdaCreditConsumptionExport = {
  __typename?: 'BillingSewSdaCreditConsumptionExport';
  fileName: Scalars['String']['output'];
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type BillingSewSdaCreditConsumptionExportInput = {
  endBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  startBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingSubscriptionSummary = {
  __typename?: 'BillingSubscriptionSummary';
  metadata: Array<BillingMetadataItem>;
  planVersion: Scalars['String']['output'];
  subscriptionVersion: Scalars['String']['output'];
  term: BillingTerm;
  tier: Scalars['String']['output'];
};

export type BillingTenantLatestSubscription = {
  __typename?: 'BillingTenantLatestSubscription';
  subscription: BillingSubscriptionSummary;
  tenantId: Scalars['String']['output'];
};

export type BillingTerm = {
  __typename?: 'BillingTerm';
  cancellationTs?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<BillingTimeInterval>;
  expirationTs?: Maybe<Scalars['Int']['output']>;
  noticePeriod?: Maybe<BillingTimeInterval>;
  postExpirationMonthlyRecurring?: Maybe<Scalars['Boolean']['output']>;
  postExpirationNoticePeriod?: Maybe<BillingTimeInterval>;
  startTs?: Maybe<Scalars['Int']['output']>;
};

export type BillingTermInterval = {
  __typename?: 'BillingTermInterval';
  endTs?: Maybe<Scalars['Int']['output']>;
  startTs: Scalars['Int']['output'];
};

export type BillingTimeInterval = {
  __typename?: 'BillingTimeInterval';
  days?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type BillingUpfrontProvisionedUsageItem = {
  __typename?: 'BillingUpfrontProvisionedUsageItem';
  billing?: Maybe<BillingProvisionedUsageBillingConfig>;
  catalogItemId?: Maybe<Scalars['String']['output']>;
  currentTerm?: Maybe<BillingTermInterval>;
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  fixedQuantity?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  packageSize?: Maybe<Scalars['String']['output']>;
  proportionalQuantity?: Maybe<BillingProportionalQuantity>;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  term?: Maybe<BillingTerm>;
};

export type BillingUsageCatalog = {
  __typename?: 'BillingUsageCatalog';
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  upfront: Array<BillingUpfrontProvisionedUsageItem>;
};

export enum BillingUsageTypeEnum {
  Licensed = 'LICENSED',
  Metered = 'METERED'
}

export type BulkFleetCapacityPatchInput = {
  ceiling?: InputMaybe<Scalars['Int']['input']>;
  desired?: InputMaybe<Scalars['Int']['input']>;
  fleetKey: Scalars['String']['input'];
  maxSize?: InputMaybe<Scalars['Int']['input']>;
  minSize?: InputMaybe<Scalars['Int']['input']>;
  readyPoolSize?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  warmBufferSize?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkFleetCapacityResultType = {
  __typename?: 'BulkFleetCapacityResultType';
  error?: Maybe<Scalars['String']['output']>;
  fleetKey: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  region: Scalars['String']['output'];
};

export type BulkResetFleetCapacityInput = {
  fleets: Array<FleetIdentifierInput>;
};

export type BulkUpdateFleetCapacityInput = {
  patches: Array<BulkFleetCapacityPatchInput>;
};

export type CapacityMetricPoint = {
  __typename?: 'CapacityMetricPoint';
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type CapacityMetricSeriesType = {
  __typename?: 'CapacityMetricSeriesType';
  dimensions: Array<DimensionValueType>;
  label: Scalars['String']['output'];
  metricName: Scalars['String']['output'];
  points: Array<CapacityMetricPoint>;
};

export type CapacityMetricsInput = {
  dimensions?: InputMaybe<Array<DimensionFilterInput>>;
  endTime: Scalars['DateTime']['input'];
  metricNames: Array<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  periodSeconds?: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
  stat?: InputMaybe<Scalars['String']['input']>;
};

export enum ConfigChangeOperation {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type ConfigChangeResponseType = {
  __typename?: 'ConfigChangeResponseType';
  appliedAt?: Maybe<Scalars['String']['output']>;
  appliedRunId?: Maybe<Scalars['String']['output']>;
  changeId: Scalars['String']['output'];
  changedAt: Scalars['String']['output'];
  changedBy: Scalars['String']['output'];
  ideName?: Maybe<Scalars['String']['output']>;
  newConfig?: Maybe<Scalars['JSON']['output']>;
  oldConfig?: Maybe<Scalars['JSON']['output']>;
  operation: ConfigChangeOperation;
  region?: Maybe<Scalars['String']['output']>;
  scopeType: ConfigChangeScopeType;
  status: ConfigChangeStatus;
};

export type ConfigChangeScopeInput = {
  ideName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scopeType: ConfigChangeScopeType;
};

export enum ConfigChangeScopeType {
  Global = 'GLOBAL',
  IdeConfig = 'IDE_CONFIG',
  IdeOverride = 'IDE_OVERRIDE'
}

export enum ConfigChangeStatus {
  Applied = 'APPLIED',
  Pending = 'PENDING',
  Superseded = 'SUPERSEDED'
}

export type CreateBackofficeResourceGroupInput = {
  name: Scalars['String']['input'];
  parentGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFeatureFlagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureName: Scalars['String']['input'];
  isPublished?: Scalars['Boolean']['input'];
};

export type CreateIdeOrchestratorConfigInput = {
  enabled?: Scalars['Boolean']['input'];
  hibernationPoolSize?: Scalars['Int']['input'];
  ideName: Scalars['String']['input'];
  idleThresholdSeconds?: Scalars['Int']['input'];
  maxInstances?: Scalars['Int']['input'];
  maxMessageAgeSeconds?: Scalars['Int']['input'];
  messagesPerInstance?: Scalars['Int']['input'];
  minInstances?: Scalars['Int']['input'];
  urgencyExtraInstances?: Scalars['Int']['input'];
};

export type CreateIdeOrchestratorConfigOverrideInput = {
  hibernationPoolSize?: InputMaybe<Scalars['Int']['input']>;
  ideName: Scalars['String']['input'];
  maxInstances?: InputMaybe<Scalars['Int']['input']>;
  minInstances?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
};

export type CreateSuperUserInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  fullNameLower?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  lastLoginTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSuperUserRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policies: Array<PolicyInput>;
  ssoGroupMapping?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSuperUserRoleUserLinkInput = {
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteFeatureFlagResponseType = {
  __typename?: 'DeleteFeatureFlagResponseType';
  affectedTenantIds: Array<Scalars['String']['output']>;
  featureName: Scalars['String']['output'];
};

export type DimensionFilterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DimensionValueType = {
  __typename?: 'DimensionValueType';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FeatureFlagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureName: Scalars['String']['input'];
  isEnabled?: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagType = {
  __typename?: 'FeatureFlagType';
  description?: Maybe<Scalars['String']['output']>;
  featureName: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum FilterOperatorEnum {
  Unknown = 'UNKNOWN',
  BeginsWith = 'begins_with',
  Between = 'between',
  Contains = 'contains',
  ContainsAny = 'contains_any',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in_',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne',
  NotContains = 'not_contains'
}

export type FleetCapacityMetricsResultType = {
  __typename?: 'FleetCapacityMetricsResultType';
  series: Array<MetricSeriesType>;
};

export type FleetIdentifierInput = {
  fleetKey: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

export type FleetSummaryType = {
  __typename?: 'FleetSummaryType';
  asgDesired?: Maybe<Scalars['Int']['output']>;
  asgMax?: Maybe<Scalars['Int']['output']>;
  asgMin?: Maybe<Scalars['Int']['output']>;
  asgName?: Maybe<Scalars['String']['output']>;
  ceiling?: Maybe<Scalars['Int']['output']>;
  fleetKey: Scalars['String']['output'];
  hasCapacityConfig: Scalars['Boolean']['output'];
  ideConfigId?: Maybe<Scalars['String']['output']>;
  isDeployed: Scalars['Boolean']['output'];
  readyPoolSize?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
  vendorId?: Maybe<Scalars['String']['output']>;
  warmBufferSize?: Maybe<Scalars['Int']['output']>;
};

export type GlobalOrchestratorConfigResponseType = {
  __typename?: 'GlobalOrchestratorConfigResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  dryRun: Scalars['Boolean']['output'];
  emaAlpha: Scalars['Float']['output'];
  emaEnabled: Scalars['Boolean']['output'];
  lastActiveTagKey: Scalars['String']['output'];
  logLevel: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
  regions: Array<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type IdeOrchestratorConfigOverrideResponseType = {
  __typename?: 'IdeOrchestratorConfigOverrideResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  hibernationPoolSize?: Maybe<Scalars['Int']['output']>;
  ideName: Scalars['String']['output'];
  maxInstances?: Maybe<Scalars['Int']['output']>;
  minInstances?: Maybe<Scalars['Int']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type IdeOrchestratorConfigResponseType = {
  __typename?: 'IdeOrchestratorConfigResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  hibernationPoolSize: Scalars['Int']['output'];
  ideName: Scalars['String']['output'];
  idleThresholdSeconds: Scalars['Int']['output'];
  maxInstances: Scalars['Int']['output'];
  maxMessageAgeSeconds: Scalars['Int']['output'];
  messagesPerInstance: Scalars['Int']['output'];
  minInstances: Scalars['Int']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  urgencyExtraInstances: Scalars['Int']['output'];
};

export type LightSuperUserResponseType = {
  __typename?: 'LightSuperUserResponseType';
  companyName?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullNameLower?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  lastLoginTimestamp?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source: UserSourceEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type LightUserResponseInterface = {
  userId: Scalars['String']['output'];
};

export type LightUserResponseType = LightUserResponseInterface & {
  __typename?: 'LightUserResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  isSystemUser?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  source: UserSourceEnum;
  termsAndConditions: TermsAndConditionsAcceptanceResponseType;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type LoginTenantResponseType = {
  __typename?: 'LoginTenantResponseType';
  idToken: Scalars['String']['output'];
};

export type MetricPointType = {
  __typename?: 'MetricPointType';
  timestamp: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MetricSeriesType = {
  __typename?: 'MetricSeriesType';
  name: Scalars['String']['output'];
  points: Array<MetricPointType>;
  source: MetricSource;
  unit: Scalars['String']['output'];
};

export enum MetricSource {
  Actual = 'ACTUAL',
  Config = 'CONFIG'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateTenant: TenantResponseType;
  bulkResetFleetCapacity: Array<BulkFleetCapacityResultType>;
  bulkUpdateFleetCapacity: Array<BulkFleetCapacityResultType>;
  createBackofficeResourceGroup: BackofficeResourceGroupResponseType;
  createIdeOrchestratorConfig: IdeOrchestratorConfigResponseType;
  createIdeOrchestratorConfigOverride: IdeOrchestratorConfigOverrideResponseType;
  createSuperTenantFeatureFlag: SuperTenantResponseType;
  createSuperUser: SuperUserResponseType;
  createSuperUserRole: SuperUserRoleResponseType;
  createSuperUserRoleUserLink: SuperUserRoleUserLinkResponseType;
  deleteBackofficeResourceGroup: BackofficeResourceGroupResponseType;
  deleteIdeOrchestratorConfig: Scalars['Boolean']['output'];
  deleteIdeOrchestratorConfigOverride: Scalars['Boolean']['output'];
  deleteSuperTenantFeatureFlag: DeleteFeatureFlagResponseType;
  deleteSuperUser: SuperUserResponseType;
  deleteSuperUserRole: SuperUserRoleResponseType;
  deleteSuperUserRoleUserLink?: Maybe<Scalars['Void']['output']>;
  loginTenant: LoginTenantResponseType;
  updateBackofficeResourceGroup: BackofficeResourceGroupResponseType;
  updateGlobalOrchestratorConfig: GlobalOrchestratorConfigResponseType;
  updateIdeOrchestratorConfig: IdeOrchestratorConfigResponseType;
  updateIdeOrchestratorConfigOverride: IdeOrchestratorConfigOverrideResponseType;
  updateSuperTenantFeatureFlag: SuperTenantResponseType;
  updateSuperUser: SuperUserResponseType;
  updateSuperUserRole: SuperUserRoleResponseType;
  updateSuperUserRoleUserLink: SuperUserRoleUserLinkResponseType;
  updateSuperUserUiPreferences: SuperUserUiPreferencesResponseType;
  updateTenant: TenantResponseType;
  updateTenantSecuritySettings: TenantResponseType;
};


export type MutationActivateTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationBulkResetFleetCapacityArgs = {
  input: BulkResetFleetCapacityInput;
};


export type MutationBulkUpdateFleetCapacityArgs = {
  input: BulkUpdateFleetCapacityInput;
};


export type MutationCreateBackofficeResourceGroupArgs = {
  backofficeResourceGroup: CreateBackofficeResourceGroupInput;
};


export type MutationCreateIdeOrchestratorConfigArgs = {
  config: CreateIdeOrchestratorConfigInput;
};


export type MutationCreateIdeOrchestratorConfigOverrideArgs = {
  override: CreateIdeOrchestratorConfigOverrideInput;
};


export type MutationCreateSuperTenantFeatureFlagArgs = {
  flag: CreateFeatureFlagInput;
  superTenantId: Scalars['String']['input'];
};


export type MutationCreateSuperUserArgs = {
  user: CreateSuperUserInput;
};


export type MutationCreateSuperUserRoleArgs = {
  userRole: CreateSuperUserRoleInput;
};


export type MutationCreateSuperUserRoleUserLinkArgs = {
  input: CreateSuperUserRoleUserLinkInput;
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
};


export type MutationDeleteBackofficeResourceGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDeleteIdeOrchestratorConfigArgs = {
  ideName: Scalars['String']['input'];
};


export type MutationDeleteIdeOrchestratorConfigOverrideArgs = {
  ideName: Scalars['String']['input'];
  region: Scalars['String']['input'];
};


export type MutationDeleteSuperTenantFeatureFlagArgs = {
  cascade?: Scalars['Boolean']['input'];
  featureName: Scalars['String']['input'];
  superTenantId: Scalars['String']['input'];
};


export type MutationDeleteSuperUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteSuperUserRoleArgs = {
  userRoleId: Scalars['String']['input'];
};


export type MutationDeleteSuperUserRoleUserLinkArgs = {
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
};


export type MutationLoginTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateBackofficeResourceGroupArgs = {
  backofficeResourceGroup: UpdateBackofficeResourceGroupInput;
  groupId: Scalars['String']['input'];
};


export type MutationUpdateGlobalOrchestratorConfigArgs = {
  config: UpdateGlobalOrchestratorConfigInput;
};


export type MutationUpdateIdeOrchestratorConfigArgs = {
  config: UpdateIdeOrchestratorConfigInput;
  ideName: Scalars['String']['input'];
};


export type MutationUpdateIdeOrchestratorConfigOverrideArgs = {
  ideName: Scalars['String']['input'];
  override: UpdateIdeOrchestratorConfigOverrideInput;
  region: Scalars['String']['input'];
};


export type MutationUpdateSuperTenantFeatureFlagArgs = {
  flag: UpdateFeatureFlagInput;
  superTenantId: Scalars['String']['input'];
};


export type MutationUpdateSuperUserArgs = {
  user: UpdateSuperUserInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateSuperUserRoleArgs = {
  userRole: UpdateSuperUserRoleInput;
  userRoleId: Scalars['String']['input'];
};


export type MutationUpdateSuperUserRoleUserLinkArgs = {
  input: UpdateSuperUserRoleUserLinkInput;
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
};


export type MutationUpdateSuperUserUiPreferencesArgs = {
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  uiPreferences?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateTenantArgs = {
  tenant: UpdateTenantInput;
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateTenantSecuritySettingsArgs = {
  tenant: UpdateTenantSecuritySettingsInput;
  tenantId: Scalars['String']['input'];
};

export type PaginatedBackofficeResourceGroupResponseType = {
  __typename?: 'PaginatedBackofficeResourceGroupResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<BackofficeResourceGroupResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedConfigChangeResponseType = {
  __typename?: 'PaginatedConfigChangeResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<ConfigChangeResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedLightUserResponseType = {
  __typename?: 'PaginatedLightUserResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<LightUserResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedSuperUserResponseType = {
  __typename?: 'PaginatedSuperUserResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<SuperUserResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedSuperUserRoleResponseType = {
  __typename?: 'PaginatedSuperUserRoleResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<SuperUserRoleResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedSuperUserRoleUserLinkResponseType = {
  __typename?: 'PaginatedSuperUserRoleUserLinkResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<SuperUserRoleUserLinkResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedTenantResponseType = {
  __typename?: 'PaginatedTenantResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<TenantResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PolicyInput = {
  action: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resource: Array<Scalars['String']['input']>;
};

export type PolicyType = {
  __typename?: 'PolicyType';
  action: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  policyId: Scalars['String']['output'];
  resource: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  fleetCapacityMetrics: FleetCapacityMetricsResultType;
  listAllIdeOrchestratorConfigOverrides: Array<IdeOrchestratorConfigOverrideResponseType>;
  listConfigChangeHistory: PaginatedConfigChangeResponseType;
  listIdeOrchestratorConfigOverrides: Array<IdeOrchestratorConfigOverrideResponseType>;
  listIdeOrchestratorConfigs: Array<IdeOrchestratorConfigResponseType>;
  listKnownFleetRegions: Array<Scalars['String']['output']>;
  listKnownFleets: Array<FleetSummaryType>;
  maxBulkPatches: Scalars['Int']['output'];
  readAllBackofficeResourceGroups: PaginatedBackofficeResourceGroupResponseType;
  readAllSuperTenants: Array<SuperTenantResponseType>;
  readAllSuperUserRoles: PaginatedSuperUserRoleResponseType;
  readAllSuperUsers: PaginatedSuperUserResponseType;
  readBackofficeResourceGroup: BackofficeResourceGroupResponseType;
  readBackofficeResourceGroupsByIds: PaginatedBackofficeResourceGroupResponseType;
  readCapacityMetrics: Array<CapacityMetricSeriesType>;
  readGlobalOrchestratorConfig: GlobalOrchestratorConfigResponseType;
  readIdeOrchestratorConfig: IdeOrchestratorConfigResponseType;
  readOrchestratorRunStatus: RunStatusResultType;
  readSreHubSummary: SreHubSummaryResponseType;
  readSubGroupsForBackofficeResourceGroup: PaginatedBackofficeResourceGroupResponseType;
  readSuperTenant: SuperTenantResponseType;
  readSuperUser: SuperUserResponseType;
  readSuperUserRole: SuperUserRoleResponseType;
  readSuperUserRoleUserLinksForUser: PaginatedSuperUserRoleUserLinkResponseType;
  readSuperUserRoleUserLinksForUserRole: PaginatedSuperUserRoleUserLinkResponseType;
  readSuperUserRolesForOwnUser: PaginatedSuperUserRoleResponseType;
  readSuperUserRolesForUser: PaginatedSuperUserRoleResponseType;
  readSuperUserUiPreferences: SuperUserUiPreferencesResponseType;
  readSuperUsersForUserRole: PaginatedSuperUserResponseType;
  readTenant: TenantResponseType;
  readTenantsForSuperTenant: PaginatedTenantResponseType;
  readUiSpeedSummary: UiSpeedSummaryResponseType;
  resalePlans: Array<BillingPlan>;
  resalePlansExport: BillingExport;
  resellerContract: BillingResellerContract;
  sewInternalCostCenterExport: BillingSewInternalCostCenterExport;
  sewInternalSapExport: BillingSewSapExport;
  sewSalesExport: BillingSewSalesExport;
  sewSapExport: BillingSewSapExport;
  sewSdaCreditConsumptionExport: BillingSewSdaCreditConsumptionExport;
  tenantsLatestSubscriptions: Array<BillingTenantLatestSubscription>;
};


export type QueryFleetCapacityMetricsArgs = {
  endTime: Scalars['DateTime']['input'];
  ideName?: InputMaybe<Scalars['String']['input']>;
  periodSeconds?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
};


export type QueryListConfigChangeHistoryArgs = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  scope?: InputMaybe<ConfigChangeScopeInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryListIdeOrchestratorConfigOverridesArgs = {
  ideName: Scalars['String']['input'];
};


export type QueryReadAllBackofficeResourceGroupsArgs = {
  filter?: InputMaybe<BackofficeResourceGroupFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllSuperUserRolesArgs = {
  filter?: InputMaybe<SuperUserRoleFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllSuperUsersArgs = {
  filter?: InputMaybe<SuperUserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadBackofficeResourceGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryReadBackofficeResourceGroupsByIdsArgs = {
  groupIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadCapacityMetricsArgs = {
  input: CapacityMetricsInput;
};


export type QueryReadIdeOrchestratorConfigArgs = {
  ideName: Scalars['String']['input'];
};


export type QueryReadOrchestratorRunStatusArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadSreHubSummaryArgs = {
  indicator: SreHubIndicator;
};


export type QueryReadSubGroupsForBackofficeResourceGroupArgs = {
  pagination?: InputMaybe<PaginationInput>;
  parentGroupId: Scalars['String']['input'];
};


export type QueryReadSuperUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryReadSuperUserRoleArgs = {
  userRoleId: Scalars['String']['input'];
};


export type QueryReadSuperUserRoleUserLinksForUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['String']['input'];
};


export type QueryReadSuperUserRoleUserLinksForUserRoleArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userRoleId: Scalars['String']['input'];
};


export type QueryReadSuperUserRolesForOwnUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadSuperUserRolesForUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['String']['input'];
};


export type QueryReadSuperUsersForUserRoleArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userRoleId: Scalars['String']['input'];
};


export type QueryReadTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryReadTenantsForSuperTenantArgs = {
  filter?: InputMaybe<TenantFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySewInternalCostCenterExportArgs = {
  params: BillingSewInternalCostCenterExportInput;
};


export type QuerySewInternalSapExportArgs = {
  params: BillingSewInternalSapExportInput;
};


export type QuerySewSalesExportArgs = {
  params: BillingSewSalesExportInput;
};


export type QuerySewSapExportArgs = {
  params: BillingSewSapExportInput;
};


export type QuerySewSdaCreditConsumptionExportArgs = {
  params: BillingSewSdaCreditConsumptionExportInput;
};


export type QueryTenantsLatestSubscriptionsArgs = {
  tenantIds: Array<Scalars['String']['input']>;
};

export enum ResourceGroupTypeEnum {
  Asset = 'ASSET',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type RunStatusEntryType = {
  __typename?: 'RunStatusEntryType';
  asgsError: Scalars['Int']['output'];
  asgsOk: Scalars['Int']['output'];
  asgsSkipped: Scalars['Int']['output'];
  asgsTotal: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  durationMs: Scalars['Float']['output'];
  requestId: Scalars['String']['output'];
  results: Scalars['JSON']['output'];
  startedAt: Scalars['String']['output'];
  triggerType: Scalars['String']['output'];
};

export type RunStatusResultType = {
  __typename?: 'RunStatusResultType';
  expectedIntervalSeconds: Scalars['Int']['output'];
  isStale: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<RunStatusEntryType>;
  lastRunAgeSeconds?: Maybe<Scalars['Float']['output']>;
  pages: Scalars['Int']['output'];
};

export enum SreHubIndicator {
  ApiLatency = 'API_LATENCY',
  Availability = 'AVAILABILITY',
  Hub = 'HUB',
  Throughput = 'THROUGHPUT'
}

export type SreHubSummaryResponseType = {
  __typename?: 'SreHubSummaryResponseType';
  summary: Scalars['JSON']['output'];
};

export type StringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsAny?: InputMaybe<Array<Scalars['String']['input']>>;
  doNotIgnoreNullable?: InputMaybe<Array<FilterOperatorEnum>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in_?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type SuperTenantResponseType = {
  __typename?: 'SuperTenantResponseType';
  appClientId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  featureFlags?: Maybe<Array<FeatureFlagType>>;
  identifier: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  latestTermsAndConditionsVersion: Scalars['Int']['output'];
  requiredMetaDataFields?: Maybe<Array<Scalars['String']['output']>>;
  superTenantId: Scalars['String']['output'];
};

export type SuperUserFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  fullNameLower?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type SuperUserResponseInterface = {
  userId: Scalars['String']['output'];
};

export type SuperUserResponseType = BackofficeBaseResponseInterface & SuperUserResponseInterface & {
  __typename?: 'SuperUserResponseType';
  companyName?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<LightSuperUserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullNameLower?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  lastLoginTimestamp?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source: UserSourceEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<LightSuperUserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userRoles: PaginatedSuperUserRoleResponseType;
};


export type SuperUserResponseTypeUserRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type SuperUserRoleFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type SuperUserRoleResponseInterface = {
  userRoleId: Scalars['String']['output'];
};

export type SuperUserRoleResponseType = BackofficeBaseResponseInterface & SuperUserRoleResponseInterface & {
  __typename?: 'SuperUserRoleResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<LightSuperUserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  isSystemRole: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  policies: Array<PolicyType>;
  ssoGroupMapping?: Maybe<Array<Scalars['String']['output']>>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<LightSuperUserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userRoleId: Scalars['String']['output'];
  users: PaginatedSuperUserResponseType;
};


export type SuperUserRoleResponseTypeUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type SuperUserRoleUserLinkResponseType = {
  __typename?: 'SuperUserRoleUserLinkResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  expirationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userRoleId: Scalars['String']['output'];
};

export type SuperUserUiPreferencesResponseType = {
  __typename?: 'SuperUserUiPreferencesResponseType';
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  uiPreferences?: Maybe<Scalars['JSON']['output']>;
};

export type TenantFilterInput = {
  companyName?: InputMaybe<StringFilterInput>;
  companyNameLower?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
};

export type TenantResponseType = {
  __typename?: 'TenantResponseType';
  companyName: Scalars['String']['output'];
  companyNameLower?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customLogo?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  enforceMfa?: Maybe<Scalars['Boolean']['output']>;
  enforceMfaForIdeaas?: Maybe<Scalars['Boolean']['output']>;
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  expirationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  featureFlags?: Maybe<Array<FeatureFlagType>>;
  groupId?: Maybe<Scalars['String']['output']>;
  importDemoData?: Maybe<Scalars['Boolean']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  manageSsoUsersInSda?: Maybe<Scalars['Boolean']['output']>;
  maxUserRoleExpirationDays?: Maybe<Scalars['Int']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<LightUserResponseType>;
  ownerId: Scalars['String']['output'];
  ssoEnabled?: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['String']['output'];
  twoFactorAuthMethods?: Maybe<Array<VerificationMethod>>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  users: PaginatedLightUserResponseType;
};


export type TenantResponseTypeUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type TermsAndConditionsAcceptanceResponseInterface = {
  termsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
};

export type TermsAndConditionsAcceptanceResponseType = TermsAndConditionsAcceptanceResponseInterface & {
  __typename?: 'TermsAndConditionsAcceptanceResponseType';
  accepted: Scalars['Boolean']['output'];
  acceptedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  latestTermsAndConditionsVersion: Scalars['Int']['output'];
  latestTermsAndConditionsVersionAccepted: Scalars['Boolean']['output'];
  superTenantId: Scalars['String']['output'];
  termsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['String']['output'];
};

export type UiSpeedSummaryResponseType = {
  __typename?: 'UiSpeedSummaryResponseType';
  summary: Scalars['JSON']['output'];
};

export type UpdateBackofficeResourceGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  parentGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureFlagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureName: Scalars['String']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGlobalOrchestratorConfigInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  emaAlpha?: InputMaybe<Scalars['Float']['input']>;
  emaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastActiveTagKey?: InputMaybe<Scalars['String']['input']>;
  logLevel?: InputMaybe<Scalars['String']['input']>;
  objectVersion: Scalars['Int']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateIdeOrchestratorConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  hibernationPoolSize?: InputMaybe<Scalars['Int']['input']>;
  idleThresholdSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxInstances?: InputMaybe<Scalars['Int']['input']>;
  maxMessageAgeSeconds?: InputMaybe<Scalars['Int']['input']>;
  messagesPerInstance?: InputMaybe<Scalars['Int']['input']>;
  minInstances?: InputMaybe<Scalars['Int']['input']>;
  objectVersion: Scalars['Int']['input'];
  urgencyExtraInstances?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIdeOrchestratorConfigOverrideInput = {
  hibernationPoolSize?: InputMaybe<Scalars['Int']['input']>;
  maxInstances?: InputMaybe<Scalars['Int']['input']>;
  minInstances?: InputMaybe<Scalars['Int']['input']>;
  objectVersion: Scalars['Int']['input'];
};

export type UpdateSuperUserInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullNameLower?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  lastLoginTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSuperUserRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  policies?: InputMaybe<Array<PolicyInput>>;
  ssoGroupMapping?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSuperUserRoleUserLinkInput = {
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTenantInput = {
  featureFlags?: InputMaybe<Array<FeatureFlagInput>>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantSecuritySettingsInput = {
  enforceMfa?: InputMaybe<Scalars['Boolean']['input']>;
  enforceMfaForIdeaas?: InputMaybe<Scalars['Boolean']['input']>;
  maxUserRoleExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  twoFactorAuthMethods?: InputMaybe<Array<VerificationMethod>>;
};

export enum UserSourceEnum {
  Saml = 'SAML',
  Sda = 'SDA',
  Unknown = 'UNKNOWN'
}

export enum VerificationMethod {
  Email = 'EMAIL',
  Mfa = 'MFA',
  Unknown = 'UNKNOWN'
}

export type BackofficeUserInfoFragment = { __typename?: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } };

export type BackofficeTenantFragment = { __typename?: 'TenantResponseType', tenantId: string, companyName: string, country?: string, ssoEnabled?: boolean, objectVersion?: number, creationTimestamp?: any, industry?: string, isActive: boolean, groupId?: string, metaData?: any, owner?: { __typename?: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } } };

export type SuperUserPolicyFragment = { __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string };

export type BaseSuperUserFragment = { __typename?: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string };

export type SuperUserForSelectFragment = { __typename?: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: UserSourceEnum, groupId?: string, objectVersion?: number, userRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', items: Array<{ __typename?: 'SuperUserRoleResponseType', isSystemRole: boolean }> } };

export type SuperUserFragment = { __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, userRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type SuperUserRoleFragment = { __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename?: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> };

export type SuperUserRoleForSelectFragment = { __typename?: 'SuperUserRoleResponseType', userRoleId: string, name: string, isSystemRole: boolean, groupId?: string, objectVersion?: number };

export type OwnSuperUserRoleFragment = { __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> };

export type SuperUserRoleLinkFragment = { __typename?: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number };

export type FeatureFlagFragmentFragment = { __typename?: 'FeatureFlagType', featureName: string, isEnabled: boolean, description?: string };

export type BackofficeResourceGroupUserInfoFragment = { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum };

export type BackofficeSubGroupFragment = { __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> };

export type BackofficeGroupTreeItemFragment = { __typename: 'BackofficeResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, fullPaths: Array<string> };

export type BackofficeResourceGroupForSelectFragment = { __typename?: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string, name: string, fullPaths: Array<string> };

export type BackofficeResourceGroupFragment = { __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, creationUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, subGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } };

export type LoginTenantForSuperTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type LoginTenantForSuperTenantMutation = { __typename?: 'Mutation', loginTenant: { __typename?: 'LoginTenantResponseType', idToken: string } };

export type ActivateTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type ActivateTenantMutation = { __typename?: 'Mutation', activateTenant: { __typename?: 'TenantResponseType', tenantId: string } };

export type UpdateBackofficeTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  tenant: UpdateTenantInput;
}>;


export type UpdateBackofficeTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'TenantResponseType', tenantId: string } };

export type UpdateTenantSecuritySettingsMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  tenant: UpdateTenantSecuritySettingsInput;
}>;


export type UpdateTenantSecuritySettingsMutation = { __typename?: 'Mutation', updateTenantSecuritySettings: { __typename?: 'TenantResponseType', tenantId: string } };

export type CreateSuperUserMutationVariables = Exact<{
  user: CreateSuperUserInput;
}>;


export type CreateSuperUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'SuperUserResponseType', userId: string } };

export type UpdateSuperUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  user: UpdateSuperUserInput;
}>;


export type UpdateSuperUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'SuperUserResponseType', userId: string } };

export type DeleteSuperUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeleteSuperUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'SuperUserResponseType', userId: string } };

export type CreateSuperUserRoleMutationVariables = Exact<{
  userRole: CreateSuperUserRoleInput;
}>;


export type CreateSuperUserRoleMutation = { __typename?: 'Mutation', createUserRole: { __typename?: 'SuperUserRoleResponseType', userRoleId: string } };

export type UpdateSuperUserRoleMutationVariables = Exact<{
  userRoleId: Scalars['String']['input'];
  userRole: UpdateSuperUserRoleInput;
}>;


export type UpdateSuperUserRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'SuperUserRoleResponseType', userRoleId: string } };

export type DeleteSuperUserRoleMutationVariables = Exact<{
  userRoleId: Scalars['String']['input'];
}>;


export type DeleteSuperUserRoleMutation = { __typename?: 'Mutation', deleteUserRole: { __typename?: 'SuperUserRoleResponseType', userRoleId: string, users: { __typename?: 'PaginatedSuperUserResponseType', items: Array<{ __typename?: 'SuperUserResponseType', userId: string }> } } };

export type CreateSuperUserRoleUserLinkMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateSuperUserRoleUserLinkMutation = { __typename?: 'Mutation', createUserRoleUserLink: { __typename?: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type DeleteSuperUserRoleUserLinkMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
}>;


export type DeleteSuperUserRoleUserLinkMutation = { __typename?: 'Mutation', deleteUserRoleUserLink?: any };

export type UpdateSuperUserRoleUserLinkMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSuperUserRoleUserLinkMutation = { __typename?: 'Mutation', updateUserRoleUserLink: { __typename?: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type CreateBackofficeResourceGroupMutationVariables = Exact<{
  resourceGroup: CreateBackofficeResourceGroupInput;
}>;


export type CreateBackofficeResourceGroupMutation = { __typename?: 'Mutation', createResourceGroup: { __typename?: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type UpdateBackofficeResourceGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  resourceGroup: UpdateBackofficeResourceGroupInput;
}>;


export type UpdateBackofficeResourceGroupMutation = { __typename?: 'Mutation', updateResourceGroup: { __typename?: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type DeleteBackofficeResourceGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type DeleteBackofficeResourceGroupMutation = { __typename?: 'Mutation', deleteResourceGroup: { __typename?: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type UpdateSuperUserUiPreferencesMutationVariables = Exact<{
  uiPreferences?: InputMaybe<Scalars['JSON']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateSuperUserUiPreferencesMutation = { __typename?: 'Mutation', updateUserUiPreferences: { __typename?: 'SuperUserUiPreferencesResponseType', uiPreferences?: any, objectVersion?: number } };

export type CreateSuperTenantFeatureFlagMutationVariables = Exact<{
  superTenantId: Scalars['String']['input'];
  flag: CreateFeatureFlagInput;
}>;


export type CreateSuperTenantFeatureFlagMutation = { __typename?: 'Mutation', createSuperTenantFeatureFlag: { __typename?: 'SuperTenantResponseType', superTenantId: string } };

export type UpdateSuperTenantFeatureFlagMutationVariables = Exact<{
  superTenantId: Scalars['String']['input'];
  flag: UpdateFeatureFlagInput;
}>;


export type UpdateSuperTenantFeatureFlagMutation = { __typename?: 'Mutation', updateSuperTenantFeatureFlag: { __typename?: 'SuperTenantResponseType', superTenantId: string } };

export type DeleteSuperTenantFeatureFlagMutationVariables = Exact<{
  superTenantId: Scalars['String']['input'];
  featureName: Scalars['String']['input'];
  cascade: Scalars['Boolean']['input'];
}>;


export type DeleteSuperTenantFeatureFlagMutation = { __typename?: 'Mutation', deleteSuperTenantFeatureFlag: { __typename?: 'DeleteFeatureFlagResponseType', featureName: string, affectedTenantIds: Array<string> } };

export type UpdateGlobalOrchestratorConfigMutationVariables = Exact<{
  config: UpdateGlobalOrchestratorConfigInput;
}>;


export type UpdateGlobalOrchestratorConfigMutation = { __typename?: 'Mutation', updateGlobalOrchestratorConfig: { __typename?: 'GlobalOrchestratorConfigResponseType', lastActiveTagKey: string, dryRun: boolean, logLevel: string, region: string, regions: Array<string>, emaAlpha: number, emaEnabled: boolean, objectVersion?: number } };

export type CreateIdeOrchestratorConfigMutationVariables = Exact<{
  config: CreateIdeOrchestratorConfigInput;
}>;


export type CreateIdeOrchestratorConfigMutation = { __typename?: 'Mutation', createIdeOrchestratorConfig: { __typename?: 'IdeOrchestratorConfigResponseType', ideName: string, minInstances: number, maxInstances: number, hibernationPoolSize: number, idleThresholdSeconds: number, messagesPerInstance: number, maxMessageAgeSeconds: number, urgencyExtraInstances: number, enabled: boolean, objectVersion?: number } };

export type UpdateIdeOrchestratorConfigMutationVariables = Exact<{
  ideName: Scalars['String']['input'];
  config: UpdateIdeOrchestratorConfigInput;
}>;


export type UpdateIdeOrchestratorConfigMutation = { __typename?: 'Mutation', updateIdeOrchestratorConfig: { __typename?: 'IdeOrchestratorConfigResponseType', ideName: string, minInstances: number, maxInstances: number, hibernationPoolSize: number, idleThresholdSeconds: number, messagesPerInstance: number, maxMessageAgeSeconds: number, urgencyExtraInstances: number, enabled: boolean, objectVersion?: number } };

export type DeleteIdeOrchestratorConfigMutationVariables = Exact<{
  ideName: Scalars['String']['input'];
}>;


export type DeleteIdeOrchestratorConfigMutation = { __typename?: 'Mutation', deleteIdeOrchestratorConfig: boolean };

export type CreateIdeOrchestratorConfigOverrideMutationVariables = Exact<{
  override: CreateIdeOrchestratorConfigOverrideInput;
}>;


export type CreateIdeOrchestratorConfigOverrideMutation = { __typename?: 'Mutation', createIdeOrchestratorConfigOverride: { __typename?: 'IdeOrchestratorConfigOverrideResponseType', ideName: string, region: string, minInstances?: number, maxInstances?: number, hibernationPoolSize?: number, objectVersion?: number } };

export type UpdateIdeOrchestratorConfigOverrideMutationVariables = Exact<{
  ideName: Scalars['String']['input'];
  region: Scalars['String']['input'];
  override: UpdateIdeOrchestratorConfigOverrideInput;
}>;


export type UpdateIdeOrchestratorConfigOverrideMutation = { __typename?: 'Mutation', updateIdeOrchestratorConfigOverride: { __typename?: 'IdeOrchestratorConfigOverrideResponseType', ideName: string, region: string, minInstances?: number, maxInstances?: number, hibernationPoolSize?: number, objectVersion?: number } };

export type DeleteIdeOrchestratorConfigOverrideMutationVariables = Exact<{
  ideName: Scalars['String']['input'];
  region: Scalars['String']['input'];
}>;


export type DeleteIdeOrchestratorConfigOverrideMutation = { __typename?: 'Mutation', deleteIdeOrchestratorConfigOverride: boolean };

export type ReadTenantsForSuperTenantQueryVariables = Exact<{
  filter?: InputMaybe<TenantFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadTenantsForSuperTenantQuery = { __typename?: 'Query', readTenantsForSuperTenant: { __typename?: 'PaginatedTenantResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'TenantResponseType', tenantId: string, companyName: string, country?: string, ssoEnabled?: boolean, objectVersion?: number, creationTimestamp?: any, industry?: string, isActive: boolean, groupId?: string, metaData?: any, owner?: { __typename?: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } } }> } };

export type ReadTenantForSuperTenantQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type ReadTenantForSuperTenantQuery = { __typename?: 'Query', readTenant: { __typename?: 'TenantResponseType', tenantId: string, companyName: string, country?: string, ssoEnabled?: boolean, objectVersion?: number, creationTimestamp?: any, industry?: string, isActive: boolean, groupId?: string, metaData?: any, owner?: { __typename?: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } } } };

export type ReadTenantFeatureFlagsQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type ReadTenantFeatureFlagsQuery = { __typename?: 'Query', readTenant: { __typename?: 'TenantResponseType', tenantId: string, objectVersion?: number, featureFlags?: Array<{ __typename?: 'FeatureFlagType', featureName: string, isEnabled: boolean, description?: string }> } };

export type ReadTenantForUpdateQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type ReadTenantForUpdateQuery = { __typename?: 'Query', readTenant: { __typename?: 'TenantResponseType', tenantId: string, objectVersion?: number, ownerId: string, groupId?: string, ssoEnabled?: boolean, metaData?: any, users: { __typename?: 'PaginatedLightUserResponseType', itemCount: number, items: Array<{ __typename?: 'LightUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: UserSourceEnum, isSystemUser?: boolean, termsAndConditions: { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, acceptedTimestamp?: any, termsAndConditionsVersion?: number, latestTermsAndConditionsVersionAccepted: boolean } }> } } };

export type ReadAllSuperUserRolesQueryVariables = Exact<{
  filter?: InputMaybe<SuperUserRoleFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllSuperUserRolesQuery = { __typename?: 'Query', readAllUserRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename?: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type ReadSuperUserRolesForSelectQueryVariables = Exact<{
  filter?: InputMaybe<SuperUserRoleFilterInput>;
}>;


export type ReadSuperUserRolesForSelectQuery = { __typename?: 'Query', readAllUserRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', items: Array<{ __typename?: 'SuperUserRoleResponseType', userRoleId: string, name: string, isSystemRole: boolean, groupId?: string, objectVersion?: number }> } };

export type ReadSuperUserRoleQueryVariables = Exact<{
  userRoleId: Scalars['String']['input'];
}>;


export type ReadSuperUserRoleQuery = { __typename?: 'Query', readUserRole: { __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename?: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> } };

export type ReadSuperUserRolesForOwnUserQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadSuperUserRolesForOwnUserQuery = { __typename?: 'Query', readSuperUserRolesForOwnUser: { __typename?: 'PaginatedSuperUserRoleResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type ReadAllSuperUsersQueryVariables = Exact<{
  filter?: InputMaybe<SuperUserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllSuperUsersQuery = { __typename?: 'Query', readAllUsers: { __typename?: 'PaginatedSuperUserResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, userRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } }> } };

export type ReadSuperUsersForSelectQueryVariables = Exact<{
  filter?: InputMaybe<SuperUserFilterInput>;
}>;


export type ReadSuperUsersForSelectQuery = { __typename?: 'Query', readAllUsers: { __typename?: 'PaginatedSuperUserResponseType', items: Array<{ __typename?: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, email: string, source: UserSourceEnum, groupId?: string, objectVersion?: number, userRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', items: Array<{ __typename?: 'SuperUserRoleResponseType', isSystemRole: boolean }> } }> } };

export type ReadSuperUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ReadSuperUserQuery = { __typename?: 'Query', readUser: { __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, userRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } } };

export type ReadSuperUsersForUserRoleQueryVariables = Exact<{
  userRoleId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadSuperUsersForUserRoleQuery = { __typename?: 'Query', readUsersForUserRole: { __typename?: 'PaginatedSuperUserResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, userRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'SuperUserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } }> } };

export type ReadSuperUserRoleUserLinksForUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ReadSuperUserRoleUserLinksForUserQuery = { __typename?: 'Query', readUserRoleUserLinksForUser: { __typename?: 'PaginatedSuperUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadSuperUserRoleUserLinksForUserRoleQueryVariables = Exact<{
  userRoleId: Scalars['String']['input'];
}>;


export type ReadSuperUserRoleUserLinksForUserRoleQuery = { __typename?: 'Query', readUserRoleUserLinksForUserRole: { __typename?: 'PaginatedSuperUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'SuperUserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadSuperTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadSuperTenantQuery = { __typename?: 'Query', readSuperTenant: { __typename?: 'SuperTenantResponseType', superTenantId: string, identifier: string, companyName: string, featureFlags?: Array<{ __typename?: 'FeatureFlagType', featureName: string, isEnabled: boolean, description?: string }> } };

export type ReadBackofficeResourceGroupByIdQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadBackofficeResourceGroupByIdQuery = { __typename?: 'Query', readResourceGroup: { __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, creationUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, subGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }, readSubGroupsForResourceGroup: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, creationUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, subGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }> } };

export type ReadBackofficeResourceGroupsToBuildTreeQueryVariables = Exact<{
  filter?: InputMaybe<BackofficeResourceGroupFilterInput>;
}>;


export type ReadBackofficeResourceGroupsToBuildTreeQuery = { __typename?: 'Query', readAllResourceGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, fullPaths: Array<string> }> } };

export type ReadAllBackofficeResourceGroupsQueryVariables = Exact<{
  filter?: InputMaybe<BackofficeResourceGroupFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllBackofficeResourceGroupsQuery = { __typename?: 'Query', readAllResourceGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, creationUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, subGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }> } };

export type ReadBackofficeResourceGroupsForSelectQueryVariables = Exact<{
  filter?: InputMaybe<BackofficeResourceGroupFilterInput>;
}>;


export type ReadBackofficeResourceGroupsForSelectQuery = { __typename?: 'Query', readAllResourceGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', items: Array<{ __typename?: 'BackofficeResourceGroupResponseType', groupId: string, parentGroupId?: string, name: string, fullPaths: Array<string> }> } };

export type ReadSubGroupsForBackofficeResourceGroupQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadSubGroupsForBackofficeResourceGroupQuery = { __typename?: 'Query', readSubGroupsForResourceGroup: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, groupType: ResourceGroupTypeEnum, isSystemGroup: boolean, fullPaths: Array<string>, updateUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, creationUser?: { __typename?: 'LightSuperUserResponseType', firstName: string, lastName: string, email: string, source: UserSourceEnum }, subGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'BackofficeResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any, fullPaths: Array<string> }> } }> } };

export type ReadBackofficeResourceGroupNamesForRoleRowQueryVariables = Exact<{
  groupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadBackofficeResourceGroupNamesForRoleRowQuery = { __typename?: 'Query', readResourceGroupsByIds: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', items: Array<{ __typename?: 'BackofficeResourceGroupResponseType', name: string, groupId: string, parentGroupId?: string }> } };

export type ReadBackofficeResourceGroupNameByIdQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadBackofficeResourceGroupNameByIdQuery = { __typename?: 'Query', readResourceGroup: { __typename?: 'BackofficeResourceGroupResponseType', name: string, parentGroupId?: string, fullPaths: Array<string> } };

export type ReadBackofficeGroupResourceCountsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadBackofficeGroupResourceCountsQuery = { __typename?: 'Query', readBackofficeResourceGroup: { __typename?: 'BackofficeResourceGroupResponseType', groupId: string, subGroups: { __typename?: 'PaginatedBackofficeResourceGroupResponseType', itemCount: number }, tenants: { __typename?: 'PaginatedTenantResponseType', itemCount: number } }, groupUsers: { __typename?: 'PaginatedSuperUserResponseType', itemCount: number }, groupRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', itemCount: number } };

export type ReadBackofficeUngroupedResourceCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadBackofficeUngroupedResourceCountsQuery = { __typename?: 'Query', groupUsers: { __typename?: 'PaginatedSuperUserResponseType', itemCount: number }, groupRoles: { __typename?: 'PaginatedSuperUserRoleResponseType', itemCount: number }, groupTenants: { __typename?: 'PaginatedTenantResponseType', itemCount: number } };

export type ReadSuperUserUiPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadSuperUserUiPreferencesQuery = { __typename?: 'Query', readUserUiPreferences: { __typename?: 'SuperUserUiPreferencesResponseType', uiPreferences?: any, objectVersion?: number } };

export type ReadGlobalOrchestratorConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadGlobalOrchestratorConfigQuery = { __typename?: 'Query', readGlobalOrchestratorConfig: { __typename?: 'GlobalOrchestratorConfigResponseType', lastActiveTagKey: string, dryRun: boolean, logLevel: string, region: string, regions: Array<string>, emaAlpha: number, emaEnabled: boolean, objectVersion?: number } };

export type ListIdeOrchestratorConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListIdeOrchestratorConfigsQuery = { __typename?: 'Query', listIdeOrchestratorConfigs: Array<{ __typename?: 'IdeOrchestratorConfigResponseType', ideName: string, minInstances: number, maxInstances: number, hibernationPoolSize: number, idleThresholdSeconds: number, messagesPerInstance: number, maxMessageAgeSeconds: number, urgencyExtraInstances: number, enabled: boolean, objectVersion?: number }> };

export type ListAllIdeOrchestratorConfigOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllIdeOrchestratorConfigOverridesQuery = { __typename?: 'Query', listAllIdeOrchestratorConfigOverrides: Array<{ __typename?: 'IdeOrchestratorConfigOverrideResponseType', ideName: string, region: string, minInstances?: number, maxInstances?: number, hibernationPoolSize?: number, objectVersion?: number }> };

export type ListConfigChangeHistoryQueryVariables = Exact<{
  scope?: InputMaybe<ConfigChangeScopeInput>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListConfigChangeHistoryQuery = { __typename?: 'Query', listConfigChangeHistory: { __typename?: 'PaginatedConfigChangeResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'ConfigChangeResponseType', changeId: string, scopeType: ConfigChangeScopeType, ideName?: string, region?: string, operation: ConfigChangeOperation, oldConfig?: any, newConfig?: any, changedBy: string, changedAt: string, status: ConfigChangeStatus, appliedAt?: string, appliedRunId?: string }> } };

export type FleetCapacityMetricsQueryVariables = Exact<{
  startTime: Scalars['DateTime']['input'];
  endTime: Scalars['DateTime']['input'];
  periodSeconds?: InputMaybe<Scalars['Int']['input']>;
  ideName?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type FleetCapacityMetricsQuery = { __typename?: 'Query', fleetCapacityMetrics: { __typename?: 'FleetCapacityMetricsResultType', series: Array<{ __typename?: 'MetricSeriesType', name: string, unit: string, source: MetricSource, points: Array<{ __typename?: 'MetricPointType', timestamp: string, value: number }> }> } };

export type ReadSuperUserNamesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadSuperUserNamesQuery = { __typename?: 'Query', readSuperUserNames: { __typename?: 'PaginatedSuperUserResponseType', itemCount: number, items: Array<{ __typename?: 'SuperUserResponseType', userId: string, firstName: string, lastName: string, email: string }> } };

export type ReadOrchestratorRunStatusQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadOrchestratorRunStatusQuery = { __typename?: 'Query', readOrchestratorRunStatus: { __typename?: 'RunStatusResultType', pages: number, itemCount: number, lastRunAgeSeconds?: number, isStale: boolean, expectedIntervalSeconds: number, items: Array<{ __typename?: 'RunStatusEntryType', startedAt: string, requestId: string, triggerType: string, durationMs: number, asgsTotal: number, asgsOk: number, asgsError: number, asgsSkipped: number, dryRun: boolean, results: any }> } };

export type ReadUiSpeedSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUiSpeedSummaryQuery = { __typename?: 'Query', readUiSpeedSummary: { __typename?: 'UiSpeedSummaryResponseType', summary: any } };

export type ReadSreHubSummaryQueryVariables = Exact<{
  indicator: SreHubIndicator;
}>;


export type ReadSreHubSummaryQuery = { __typename?: 'Query', readSreHubSummary: { __typename?: 'SreHubSummaryResponseType', summary: any } };

export type ReadSuperTenantFeatureFlagCatalogsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadSuperTenantFeatureFlagCatalogsQuery = { __typename?: 'Query', readAllSuperTenants: Array<{ __typename?: 'SuperTenantResponseType', superTenantId: string, identifier: string, featureFlags?: Array<{ __typename?: 'FeatureFlagType', featureName: string, description?: string, isPublished: boolean }> }> };

export type SewSalesExportQueryVariables = Exact<{
  startBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  endBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SewSalesExportQuery = { __typename?: 'Query', sewSalesExport: { __typename?: 'BillingSewSalesExport', url: string, log?: string, hasErrors?: boolean } };

export type SewCreditConsumptionExportQueryVariables = Exact<{
  startBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  endBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SewCreditConsumptionExportQuery = { __typename?: 'Query', sewSdaCreditConsumptionExport: { __typename?: 'BillingSewSdaCreditConsumptionExport', url: string, log?: string, hasErrors?: boolean } };

export type SewSapExportQueryVariables = Exact<{
  billingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  region: BillingSewRegionEnum;
}>;


export type SewSapExportQuery = { __typename?: 'Query', sewSapExport: { __typename?: 'BillingSewSapExport', url: string, log?: string, hasErrors?: boolean } };

export type SewInternalSapExportQueryVariables = Exact<{
  billingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SewInternalSapExportQuery = { __typename?: 'Query', sewInternalSapExport: { __typename?: 'BillingSewSapExport', url: string, log?: string, hasErrors?: boolean } };

export type SewInternalCostCenterExportQueryVariables = Exact<{
  startBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  endBillingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SewInternalCostCenterExportQuery = { __typename?: 'Query', sewInternalCostCenterExport: { __typename?: 'BillingSewInternalCostCenterExport', url: string, log?: string, hasErrors?: boolean } };

export type ResalePlansExportQueryVariables = Exact<{ [key: string]: never; }>;


export type ResalePlansExportQuery = { __typename?: 'Query', resalePlansExport: { __typename?: 'BillingExport', url: string } };

export type ReadTenantsLatestSubscriptionsQueryVariables = Exact<{
  tenantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadTenantsLatestSubscriptionsQuery = { __typename?: 'Query', tenantsLatestSubscriptions: Array<{ __typename?: 'BillingTenantLatestSubscription', tenantId: string, subscription: { __typename?: 'BillingSubscriptionSummary', tier: string, term: { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number } } }> };

export type FleetSummaryFragment = { __typename?: 'FleetSummaryType', fleetKey: string, region: string, vendorId?: string, ideConfigId?: string, asgName?: string, isDeployed: boolean, hasCapacityConfig: boolean, ceiling?: number, warmBufferSize?: number, readyPoolSize?: number, asgDesired?: number, asgMin?: number, asgMax?: number };

export type BulkFleetCapacityResultFragment = { __typename?: 'BulkFleetCapacityResultType', fleetKey: string, region: string, ok: boolean, error?: string };

export type CapacityMetricSeriesFragment = { __typename?: 'CapacityMetricSeriesType', metricName: string, label: string, dimensions: Array<{ __typename?: 'DimensionValueType', name: string, value: string }>, points: Array<{ __typename?: 'CapacityMetricPoint', timestamp: any, value: number }> };

export type BulkUpdateFleetCapacityMutationVariables = Exact<{
  input: BulkUpdateFleetCapacityInput;
}>;


export type BulkUpdateFleetCapacityMutation = { __typename?: 'Mutation', bulkUpdateFleetCapacity: Array<{ __typename?: 'BulkFleetCapacityResultType', fleetKey: string, region: string, ok: boolean, error?: string }> };

export type BulkResetFleetCapacityMutationVariables = Exact<{
  input: BulkResetFleetCapacityInput;
}>;


export type BulkResetFleetCapacityMutation = { __typename?: 'Mutation', bulkResetFleetCapacity: Array<{ __typename?: 'BulkFleetCapacityResultType', fleetKey: string, region: string, ok: boolean, error?: string }> };

export type ListKnownFleetsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListKnownFleetsQuery = { __typename?: 'Query', listKnownFleets: Array<{ __typename?: 'FleetSummaryType', fleetKey: string, region: string, vendorId?: string, ideConfigId?: string, asgName?: string, isDeployed: boolean, hasCapacityConfig: boolean, ceiling?: number, warmBufferSize?: number, readyPoolSize?: number, asgDesired?: number, asgMin?: number, asgMax?: number }> };

export type ListKnownFleetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListKnownFleetRegionsQuery = { __typename?: 'Query', listKnownFleetRegions: Array<string> };

export type MaxBulkPatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type MaxBulkPatchesQuery = { __typename?: 'Query', maxBulkPatches: number };

export type ReadCapacityMetricsQueryVariables = Exact<{
  input: CapacityMetricsInput;
}>;


export type ReadCapacityMetricsQuery = { __typename?: 'Query', readCapacityMetrics: Array<{ __typename?: 'CapacityMetricSeriesType', metricName: string, label: string, dimensions: Array<{ __typename?: 'DimensionValueType', name: string, value: string }>, points: Array<{ __typename?: 'CapacityMetricPoint', timestamp: any, value: number }> }> };
